import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '报表指标',
    type: 'AMAR_RI',
}